import { DialogService, GridAction } from '@eforall/dashboard';
import { AccGoalComment, DialogMode } from '@interfaces';
import { GoalCommentEditorDialog } from '../../../comment-editor/comment-editor.dialog';
import { GoalCommentEditorDialogData } from '../../../goal-dialog-data';
import { GoalDetailsDialogDataService } from '../../goal-details-dialog-data.service';

export function getActions(dialogService: DialogService, dialogDataService: GoalDetailsDialogDataService) {

	const actions: GridAction<AccGoalComment>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Edit Comment',
			isEnabled: rows => dialogDataService.canEdit() && !!rows.length,
			execute: async rows => {
				const accGoalId = dialogDataService.goalDetails()?.accGoalId;
				const r = rows[0]!;
				const dialogData: GoalCommentEditorDialogData = {
					mode: DialogMode.EDIT,
					accGoalCommentId: r.accGoalCommentId,
					comment: r.comment,
				};
				await dialogService.showCustom<GoalCommentEditorDialog, GoalCommentEditorDialogData>(GoalCommentEditorDialog, { data: dialogData }, 500, 280);
				await dialogDataService.loadDetails(accGoalId!);
			}
		}
	];

	return actions;
}